<template>
	<div class="nobox">
		<div class="block-title">充电桩状态</div>
		<div class="boxnav">
			<div style="display: flex; justify-items: center">
				<!-- <div ref="chartEquipDiv" class="" style="height: 170px; width: 50%"></div> -->
				<div ref="chartStatusDiv" class="" style="height: 250px; width: 100%"></div>
			</div>
			<!-- <div class="leidanav">
        <ul class="clearfix">
          <li>
            <span>充电枪总数</span>
            <p>{{ totalNum }}</p>
          </li>
          <li>
            <span>充电中</span>
            <p>{{ chargingNum }}</p>
          </li>
          <li>
            <span>占桩中</span>
            <p>{{ occupyingNum }}</p>
          </li>
        </ul>
      </div> -->
		</div>
	</div>
</template>
<script>
	import * as echarts from 'echarts';

	export default {
		data() {
			return {
				totalNum: 0,
				chargingNum: 0,
				occupyingNum: 0,
				// equipCharts: null,
				statusCharts: null,
			}
		},
		mounted() {
			// this.equipCharts = echarts.init(this.$refs.chartEquipDiv);
			this.statusCharts = echarts.init(this.$refs.chartStatusDiv);
			// this.equipCharts.setOption(chartEquipOption);
			this.statusCharts.setOption(chartStatusOption);
			window.addEventListener('resize', () => {
				// this.equipCharts.resize();
				this.statusCharts.resize();
			});
		},
		methods: {
			setData(data) {
				const sum = {
					totalNum: 0,
					zhiliuNum: 0,
					jiaoliuNum: 0,
					diandancheNum: 0,
					disuoNum: 0,

					standbyNum: 0,
					chargingNum: 0,
					offlineNum: 0,
					breakdownDevNum: 0,
					occupyDevNum: 0,
				};

				data.forEach((element) => {
					sum.totalNum += element.TotalDevNum;
					sum.zhiliuNum += element.ZhiliuDevNum;
					sum.jiaoliuNum += element.JiaoliuDevNum;
					sum.diandancheNum += element.DiandancheDevNum;
					sum.disuoNum += element.DisuoDevNum;

					sum.standbyNum += element.StandbyDevNum;
					sum.chargingNum += element.WorkingDevNum;
					sum.offlineNum += element.OfflineDevNum;
					sum.breakdownDevNum += element.BreakdownDevNum;
					sum.occupyDevNum += element.OccupyDevNum;
				});

				// chartEquipOption.title.text = `${sum.totalNum}\r\n总数`;
				// chartEquipOption.series[0].data[0].value = sum.zhiliuNum;
				// chartEquipOption.series[0].data[1].value = sum.jiaoliuNum;
				// chartEquipOption.series[0].data[2].value = sum.disuoNum;
				// chartEquipOption.series[0].data[3].value = sum.diandancheNum;
				// this.equipCharts.setOption(chartEquipOption);

				chartStatusOption.title.text = `${sum.totalNum}\r\n总数`;
				chartStatusOption.series[0].data[0].value = sum.standbyNum;
				chartStatusOption.series[0].data[1].value = sum.chargingNum;
				chartStatusOption.series[0].data[2].value = sum.offlineNum;
				chartStatusOption.series[0].data[3].value = sum.breakdownDevNum;
				this.statusCharts.setOption(chartStatusOption);

				// this.totalNum = sum.totalNum;
				// this.chargingNum = sum.chargingNum;
				// this.occupyingNum = sum.occupyDevNum;
			}
		}
	}

	// let chartEquipOption = {
	//   color: ['#BDF090', '#4DCEF8', '#6C92F8', '#FF9F7F'],
	//   title: {
	//     text: '0\n\n总数',
	//     left: '33%',
	//     top: 'middle',
	//     textAlign: 'center',
	//     textStyle: { color: 'white', fontSize: 14 },
	//   },
	//   tooltip: {
	//     trigger: 'item',
	//     formatter: '{b}<br/>{c} ({d}%)',
	//   },
	//   legend: {
	//     orient: 'vertical',
	//     right: 10,
	//     top: 'middle',
	//     data: ['直流', '交流', '地锁', '电单车'],
	//     itemWidth: 18,
	//     itemHeight: 12,
	//     textStyle: {
	//       color: '#929ca8',
	//       fontSize: 10,
	//     },
	//   },
	//   series: [
	//     {
	//       name: '设备类型',
	//       type: 'pie',
	//       radius: ['35%', '45%'],
	//       center: ['35%', '50%'],
	//       // avoidLabelOverlap: false,
	//       label: {
	//         show: false,
	//         position: 'outside',
	//         formatter: '{b} ({c})',
	//         textShadowColor: 'transparent',
	//         textShadowBlur: 0,
	//       },
	//       data: [
	//         { value: 0, name: '直流' },
	//         { value: 0, name: '交流' },
	//         { value: 0, name: '地锁' },
	//         { value: 0, name: '电单车' },
	//       ],
	//     },
	//   ],
	// };
	let chartStatusOption = {
		color: ['#BDF090', '#4DCEF8', '#BBBBBB', '#FF9F7F'],
		title: {
			text: '0\n\n总数',
			left: '54%',
			top: 'middle',
			textAlign: 'center',
			textStyle: {
				color: 'white',
				fontSize: 14
			},
		},
		tooltip: {
			trigger: 'item',
			formatter: '{b}<br/>{c} ({d}%)',
		},
		legend: {
			orient: 'vertical',
			left: 10,
			top: 'top',
			data: ['空闲', '充电', '离线', '故障'],
			itemWidth: 18,
			itemHeight: 12,
			textStyle: {
				color: '#929ca8',
				fontSize: 10,
			},
		},
		series: [{
			name: '设备状态',
			type: 'pie',
			radius: ['35%', '50%'],
			center: ['55%', '50%'],
			// avoidLabelOverlap: false,
			label: {
				show: true,
				position: 'outside',
				color: '#eee',
				formatter: '{b} ({c})',
			},
			data: [{
					value: 0,
					name: '空闲'
				},
				{
					value: 0,
					name: '充电'
				},
				{
					value: 0,
					name: '离线'
				},
				{
					value: 0,
					name: '故障'
				},
			],
		}, ],
	};
</script>
<style type="less" scoped>
	@import '../style.css';
</style>